// No Leaflet import here: this file must run under Bun without a DOM.
export type TileSet = { id: 'atlas' | 'satellite'; label: string; url: string };

// Base layers the layer switcher offers, in order; the first one is shown at start. A set
// without a configured URL is left out, so with only the atlas there is nothing to switch.
export function tileSets(env: Record<string, string | undefined> = import.meta.env): TileSet[] {
  const sets: { id: TileSet['id']; label: string; url: string | undefined }[] = [
    // Older configurations name the tile set in the URL; Leaflet has no value for {set}.
    { id: 'atlas', label: 'Karte', url: env.VITE_MAP_TILE_URL?.replaceAll('{set}', 'atlas') },
    { id: 'satellite', label: 'Satellit', url: env.VITE_MAP_SATELLITE_URL },
  ];
  return sets.filter((set): set is TileSet => Boolean(set.url));
}
